<div class="kng-customer-session" id="session-header" *ngIf="!customerState.hidden">
  <div class="kng-customer-session__content">
    <div class="kng-customer-session__content__item">
      <span class="kng-customer-session__content__item__label"> <b> {{ customerState.readOnly }} </b> </span>
      <span class="kng-customer-session__content__item__label"> {{ customerState.warningNote }} </span>
      <span class="kng-customer-session__content__item__label"><b> {{customerState.username | titlecase}} </b> sees it.</span>
    </div>
    <div class="kng-customer-session__link">
      <span (click)="endCustomerSession()"> {{customerState.endSession}} </span>
    </div>
  </div>
</div>
<div class="kng-header-nav" id="portal-header" [ngClass]="{ 'removed-header': !headerBottom.minimumAccess}">
  <div class="kng-header-nav__mobile">
    <div class="kng-header-nav__mobile__items">
      <header>
        <button mat-button class="menu-button" (click)="isRaymond ? setRaymondAnalyticReportingHeading(true) : sidenav.open()">
          <mat-icon tabindex="0">menu</mat-icon>
        </button>
        <ng-container class="logos" *ngFor="let options of headerlogos; let i = index">
          <img  *ngIf="options.cssClass !== 'ui__nav__mobile__notification'" class="logos__{{ i }}" src="{{isRaymond && options.cssClass === 'ui__nav__mobile__notification'? 'assets/images/raymond-notification-alert-mobile.svg' : options?.iconPath }}" alt="{{ options?.altText }}" tabindex="0"
            (click)="logoClicked($event, options)" />
        </ng-container>
      </header>
    </div>
  </div>
  <div class="kng-header-nav__section kng-header-nav__section--top" [ngClass]="{ 'removed-header': !headerBottom.minimumAccess}" *ngIf="headerTop.menu.length > 0">
    <div class="kng-header-nav__section__options justify-content-flex-end">
      <div #menuItem *ngFor="let option of headerTop.menu">
        <div class="kng-header-nav__section__options__item" *ngIf="(option.label !== 'Roles and Permissions' || !isRaymond) && option.cssClass !== 'ui__nav__global__notification'"> 
        <button class="kng-header-nav__section__options__item__header__label" class="{{ option.cssClass }}"
          [ngClass]="{ 'minimum_access': headerTop.minimumAccess, 'non-clickable': option.notClickable, 'ui__nav__global__user_isRaymond': isRaymond && option.cssClass === 'ui__nav__global__user' }"
          tabindex={{navTabIndex}} *ngIf="option.label !== cssClass.skipNav" (click)="selectHeaderMenu(option, $event)">
          <img src="{{ option?.iconPath }}" alt="{{ option.altText }}" />
          <span *ngIf="option.cssClass === cssClass.shop">{{
            option?.label
            }}</span>
          <span *ngIf="!showEllipsis(option.label) && option.cssClass === cssClass.user && !(locationListArray && locationListArray.length > 0)"
            [ngClass]="{selected_item: (userSelected || headerTop.minimumAccess) }">
            {{ option?.label }}</span>
          <span *ngIf="showEllipsis(option.label) && option.cssClass === cssClass.user && !(locationListArray && locationListArray.length > 0)"
            [ngClass]="{selected_item: (userSelected || headerTop.minimumAccess) }">
            {{ option.label.substr(0, 21) }}...</span>
          <span *ngIf="locationListArray && locationListArray.length > 0 && option.cssClass === cssClass.user"
            [ngClass]="{selected_item: (userSelected || headerTop.minimumAccess) }">
            {{ username }}
          </span>
          <span class="dropdown-padding dropdown-width" *ngIf="option.cssClass === cssClass.locationListDropdown && locationListArray && locationListArray.length > 0">
            <div class="kng-header-nav__section__options__item__suboptions__header" #subLocationItem *ngIf="showLocationDropdown">
              <div *ngFor="let location of locationListArray" tabindex={{navTabIndex}}
                (mouseover)="displayLocationMenu()" (mouseleave)="closeLocationMenu()"
                (click)="selectSubLocationOption(location, 'header')"
                (keyup.enter)="selectSubLocationOption(location, 'header')"
                class="kng-header-nav__section__options__item__suboptions__header__item">
                <span>{{ location.accountName }}</span>
              </div>
            </div>
            <span *ngIf="!accountNameEllipsis" (mouseover)="displayLocationMenu()" (mouseleave)="closeLocationMenu()" (click)="clickDropdownArrow()">{{ selectedLocation?.accountName }}<img [ngClass]="{'invert-arrow': showLocationDropdown, 'dropdown-padding':!showLocationDropdown}" src="{{ option?.dropdownArrow?.iconPath }}" alt="" tabindex="-1"/></span>
            <span *ngIf="accountNameEllipsis" (mouseover)="displayLocationMenu()" (mouseleave)="closeLocationMenu()" (click)="clickDropdownArrow()">{{ selectedLocation?.accountName?.substr(0, 10) }}...<img [ngClass]="{'invert-arrow': showLocationDropdown, 'dropdown-padding':!showLocationDropdown}" src="{{ option?.dropdownArrow?.iconPath }}" alt="" tabindex="-1"/></span>
          </span>
        </button>
        <div class="kng-header-nav__section__options__item__suboptions__header" [ngClass]="{ 'settings-dropdown-alignment-raymond': isRaymond }" #subMenuItem *ngIf="showSettingsMenu">
          <div *ngFor="let subOption of subOptionArray" tabindex={{navTabIndex}}
            [ngClass]="{ selected: subOption.isSelected && subOption.label !== switchRole, 'roles_permission': subOption.label === 'Roles and Permissions' && isRaymond }" (mouseover)="displayMenu()" (mouseleave)="closeMenu()"
            (click)="selectSubOption(subOption, 'header', $event)"
            (keyup.enter)="selectSubOption(subOption, 'header', $event)"
            class="kng-header-nav__section__options__item__suboptions__header__item">
            <span>{{ subOption.label }}</span>
          </div>
        </div>
      </div>
        <div [ngClass]="{'skip-nav-not-am': !(locationListArray && locationListArray.length > 0)}" class="skip-nav" *ngIf="option.label === cssClass.skipNav">
          <button class="nav-link" (click)="skipNavigation()" tabindex="0">{{skipNavText}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="kng-header-nav__section kng-header-nav__section--bottom"
    *ngIf="headerBottom.menu && headerBottom.menu.length > 0 && !headerBottom.minimumAccess">
    <div class="kng-header-nav__section__options justify-content-space-between">
      <ng-container  *ngFor="let option of headerBottom.menu">
        <div class="section_sec" *ngIf="!option.hideMenu">
          <div (click)="selectNavMenu(option, 'nav', $event)" (keypress)="selectNavMenu(option, 'nav', $event)"
            class="kng-header-nav__section__options__item" >
            <div class="kng-header-nav__section__options__item__nav__label"
              [ngClass]="{ selected_item: option.isSelected && !unSelectNav}" tabindex={{navTabIndex}}>
              {{ option?.label }}
              <span *ngIf="isRaymond && option.submenu?.length"><img class="kng-header-nav__section__options__item__nav__label__img" [src]="option.isSelected ? 'assets/images/chevronDownBlack.svg' : 'assets/images/chevronDownWhite.svg'" alt="action" tabindex="0"/></span>
            </div>
            <ng-container *ngIf="!isRaymond">
              <div class="kng-header-nav__section__options__item__suboptions__nav" *ngFor="let subOption of option.submenu">
                <div (click)="selectSubOption(subOption, 'nav', $event)" [ngClass]="{ selected_item: subOption.isSelected }"
                  class="kng-header-nav__section__options__item__suboptions__nav__item">
                  <span>{{ subOption?.label }}</span>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="isRaymond && showPortalSubmenu">
              <div class="kng-header-nav__section__options__item__suboptions__nav raymond">
                <div *ngFor="let subOption of option.submenu" tabindex={{navTabIndex}}
                  (click)="selectSubOption(subOption, 'nav', $event)" 
                  (keyup.enter)="selectSubOption(subOption, 'nav', $event)"
                  (mouseover)="displayMenu()" (mouseleave)="closeMenu()"
                  [ngClass]="{ selected: subOption.isSelected }"
                  class="kng-header-nav__section__options__item__suboptions__nav__item">
                  <span>{{ subOption?.label }}</span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

    </div>
  </div>
</div>
<mat-sidenav-container #sidenav class="sidenavcontainer" mode="side" hasBackdrop="false">
  <mat-sidenav class="sidenavcontainer__sidenav">
    <div class="sidenavcontainer__sidenav__menu-header">
      <span tabindex="0" *ngIf="!isRaymond">Menu</span>
      <span tabindex="0" *ngIf="isRaymond" class="raymond-mobile-menu-top-section">
        <img src="assets/images/raymond-user-profile-icon-mobile-view.svg" alt="" />
          {{username}}
      </span>
      <button class="sidenavcontainer__sidenav__menu-header__closebutton" (click)="sidenav.close()" tabindex="0">
        <img class="sidenavcontainer__sidenav__menu-header__closebutton__icon" aria-hidden="false"
          src="/assets/Icon Color.svg" alt="Close">
      </button>
    </div>
    <mat-sidenav-content>
      <div *ngFor="let option of mobileHeaderMenu?.menu" class="sidenavcontainer__sidenav__menu-content">
        <div *ngIf="option.cssClass === cssClass.locationListDropdown && locationListArray && locationListArray.length > 0 && option.label !== 'Analytics/Reporting'">
          <div class="sidenavcontainer__sidenav__menu-content__menu-items">
            <div class="dropdown-border">
              <button tabindex="0" id="company-accordion" class="accordion"  (click)="toggleHelper($event, accordion, panel)" (keypress)="toggleHelper($event, accordion, panel)" #accordion>{{selectedLocation?.accountName}}<img class="accordion-arrow" src="{{ option?.dropdownArrow?.iconPath }}" alt="" tabindex="-1"/></button>
              <div class="panel" #panel>
                <div *ngFor="let location of locationListArray" class="company-location" tabindex="0" (click)="selectSubLocationOptionMobile(location)" (keypress)="selectSubLocationOptionMobile(location)"> {{ location.accountName }} </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="option.cssClass !== cssClass.locationListDropdown && option?.label !== 'Analytics/Reporting' && (option.label!== 'Roles and Permissions' || !isRaymond)" (click)="selectMobileMenu(option, $event)" (keypress)="selectMobileMenu(option, $event)" tabindex="0">
          <div class="sidenavcontainer__sidenav__menu-content__menu-items">
            <div class="{{ option.cssClass }}">
              <span [ngClass]="{ selected_item: option.isSelected && unSelectMobileHeader}">
                {{ option.label }}
              </span>
              <img *ngIf="option.iconPath !== ''" src="{{ option.iconPath }}" alt="{{ option.altText }}" />
            </div>
          </div>
        </div>
        <div *ngIf="option?.label === 'Analytics/Reporting' && isRaymond">
          <div class="sidenavcontainer__sidenav__menu-content__menu-items">
            <div class="dropdown-border">
              <button tabindex="0" id="company-accordion" class="accordion aAndL-mobile-dropdown"  (click)="toggleHelper($event, accordion, panel)" (keypress)="toggleHelper($event, accordion, panel)" #accordion>{{option?.label}}<img class="accordion-arrow" src="assets/images/chevron_down.png" alt="" tabindex="-1"/></button>
              <div class="panel" #panel>
                <div *ngFor="let submenu of option?.submenu" class="aAndL-mobile-dropdown-options" [ngClass]="{ selected_item: submenu?.isSelected}" tabindex="0" (click)="submenuMobileAnalyticsClicked(submenu)" (keypress)="submenuMobileAnalyticsClicked(submenu)"> {{ submenu?.label}} </div>
              </div>
            </div>
          </div>
        </div> 
      </div>
    </mat-sidenav-content>
  </mat-sidenav>
</mat-sidenav-container>
